module.exports = __webpack_public_path__ + "media/backgrounds/gray-mail-80e97c95.svg";